import { call, put, takeLatest } from 'redux-saga/effects'
import apiCall from '../helpers/apiCall'
import { GET } from '../consts/methods'
import { SET_LOADER } from 'dealer-reducers'
import { FETCH_BRANDS, FETCH_BRANDS_SUCCESS, FETCH_BRANDS_FAILURE, Brand } from 'src/redux/brandsReducer'

type Response = Brand[]

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function* FetchBrandsFlow(): Generator<any, void, any> {
  try {
    yield put(SET_LOADER(true))
    const endpoint = '/dealers_api/brands'
    const response: Response = yield call(apiCall, {
      endpoint,
      api: 'market-api',
      method: GET,
      params: {}
    })
    yield put(
      FETCH_BRANDS_SUCCESS({
        brands: response
      })
    )
  } catch (error) {
    yield put(FETCH_BRANDS_FAILURE())
  } finally {
    yield put(SET_LOADER(false))
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function* FetchBrandsSaga(): Generator<any, void, any> {
  yield takeLatest(FETCH_BRANDS, FetchBrandsFlow)
}
